import styled from "styled-components";

export const WalletLogsFilterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 16px 12px;

  > .title {
    font-weight: 700;
    font-size: 20px;
  }
`;
export const WalletLogsFilterBox = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
